export default function initFormRepeater(): void {
    const repeaterFields = document.querySelectorAll<HTMLElement>('.gfield--type-repeater_end');
    repeaterFields.forEach(field => new FormRepeater(field));
}

class FormRepeater {
    $field: HTMLElement;
    $itemsWrapper: HTMLElement | null;
    $footer: HTMLElement | null;
    $removeButton: HTMLButtonElement;

    constructor($field: HTMLElement) {
        this.$field = $field;
        this.$itemsWrapper = $field.querySelector('.repeater-field-warp-item');
        this.$footer = $field.querySelector('.repeater-field-footer');
        this.$removeButton = this.createRemoveButton();

        this.init();
    }

    createRemoveButton(): HTMLButtonElement {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.classList.add('gf-repeater-field-button-remove');
        btn.textContent = 'Supprimer le dernier participant';
        return btn;
    }

    init(): void {
        if (!this.$footer || !this.$itemsWrapper) return;

        this.$footer.appendChild(this.$removeButton);

        this.$removeButton.addEventListener('click', () => {
            const items = this.$itemsWrapper?.querySelectorAll<HTMLElement>('.repeater-field-item');
            if (!items || items.length <= 1) return;

            const lastItem = items[items.length - 1];
            const removeBtn = lastItem.querySelector<HTMLElement>('.repeater-field-header-acctions-remove');
            removeBtn?.click();
        });

        // Observer les ajouts/suppressions d'items pour mettre à jour la visibilité
        const observer = new MutationObserver(() => this.updateRemoveButtonVisibility());
        observer.observe(this.$itemsWrapper, { childList: true, subtree: false });

        this.updateRemoveButtonVisibility();
    }

    updateRemoveButtonVisibility(): void {
        const count = this.$itemsWrapper?.querySelectorAll('.repeater-field-item').length ?? 0;
        this.$removeButton.classList.toggle('is-hidden', count <= 1);
    }
}
